export function normalizeApiResponse(resp, fallbackPerPage = 20) {
  if (resp && typeof resp === 'object' && 'data' in resp && 'headers' in resp) {
    return { data: resp.data, headers: resp.headers };
  }

  if (resp && typeof resp === 'object' && 'data' in resp && 'meta' in resp) {
    const meta = resp.meta || {};
    const headers = {
      'x-total-count': String(meta.total ?? 0),
      'x-total-pages': String(meta.totalPages ?? Math.ceil((meta.total ?? 0) / (meta.per_page ?? fallbackPerPage) || 1)),
      'x-page': String(meta.page ?? 1),
      'x-per-page': String(meta.per_page ?? fallbackPerPage)
    };
    return { data: resp.data ?? [], headers };
  }

  // Fallback genérico
  return { data: Array.isArray(resp) ? resp : [], headers: {} };
}
